package com.raouf.mehrguard.web.i18n

internal val PersianStrings = mapOf(
    WebStringKey.AppName to "Mehr Guard",
    WebStringKey.AppTagline to "ردیاب QRishing با Kotlin Multiplatform",
    WebStringKey.MenuMain to "منوی اصلی",
    WebStringKey.MenuSecurity to "امنیت",
    WebStringKey.MenuSystem to "سیستم",
    WebStringKey.NavDashboard to "داشبورد",
    WebStringKey.NavScanMonitor to "مانیتور اسکن",
    WebStringKey.NavScanHistory to "تاریخچه اسکن",
    WebStringKey.NavTrustCentre to "مرکز اعتماد",
    WebStringKey.NavReports to "گزارش‌ها",
    WebStringKey.NavTraining to "آموزش",
    WebStringKey.NavSettings to "تنظیمات",
    WebStringKey.QuickActions to "اقدامات سریع",
    WebStringKey.HeroTagline to "امن. آفلاین.",
    WebStringKey.HeroTagline2 to "دفاع قابل توضیح.",
    WebStringKey.HeroDescription to "Mehr Guard تهدیدات بالقوه را مستقیماً روی سخت‌افزار شما تحلیل می‌کند. حفاظت بدون تأخیر را تجربه کنید.",
    WebStringKey.StartScan to "شروع اسکن جدید",
    WebStringKey.ImportImage to "وارد کردن تصویر",
    WebStringKey.ScanQrCode to "اسکن کد QR",
    WebStringKey.SystemHealth to "سلامت سیستم",
    WebStringKey.ThreatDatabase to "پایگاه داده تهدیدات",
    WebStringKey.Current to "فعلی",
    WebStringKey.Active to "فعال",
    WebStringKey.Threats to "تهدیدها",
    WebStringKey.SafeScans to "اسکن‌های امن",
    WebStringKey.EngineActive to "موتور فعال",
    WebStringKey.EnterpriseProtection to "حفاظت سازمانی فعال",
    WebStringKey.SystemOptimal to "سیستم بهینه",
    WebStringKey.OfflineReady to "آماده کار آفلاین",
    WebStringKey.TrustCentreTitle to "مرکز اعتماد",
    WebStringKey.OfflineGuarantee to "تضمین آفلاین سخت‌گیرانه",
    WebStringKey.ThreatSensitivity to "حساسیت به تهدید",
    WebStringKey.Analyze to "تحلیل",
    WebStringKey.HeuristicEngine to "موتور اکتشافی",
    WebStringKey.RecentScans to "اسکن‌های اخیر",
    WebStringKey.ViewFullHistory to "مشاهده تاریخچه کامل",
    WebStringKey.Status to "وضعیت",
    WebStringKey.Source to "منبع",
    WebStringKey.Details to "جزئیات",
    WebStringKey.Time to "زمان",
    WebStringKey.Version to "نسخه",
    WebStringKey.Signatures to "امضاها",
    WebStringKey.CheckForUpdates to "بررسی به‌روزرسانی‌ها",
    WebStringKey.NoScansYet to "هنوز اسکنی انجام نشده. اسکن جدیدی شروع کنید تا نتایج را اینجا ببینید.",
    WebStringKey.VerdictSafe to "امن",
    WebStringKey.VerdictPhish to "فیشینگ",
    WebStringKey.VerdictWarn to "هشدار",
    WebStringKey.ActiveScanner to "اسکنر فعال",
    WebStringKey.OfflineMode to "حالت آفلاین",
    WebStringKey.CameraAccessRequired to "دسترسی به دوربین لازم است",
    WebStringKey.EnableCamera to "فعال‌سازی دوربین",
    WebStringKey.Scanning to "در حال اسکن...",
    WebStringKey.Torch to "چراغ قوه",
    WebStringKey.Gallery to "گالری",
    WebStringKey.PasteUrl to "جایگذاری لینک",
    WebStringKey.AnalyzeUrl to "تحلیل لینک",
    WebStringKey.SystemStatus to "وضعیت سیستم",
    WebStringKey.PhishingEngine to "موتور فیشینگ",
    WebStringKey.Ready to "آماده",
    WebStringKey.Latency to "تأخیر",
    WebStringKey.ViewAll to "مشاهده همه",
    WebStringKey.VerdictHighRisk to "خطر بالا شناسایی شد",
    WebStringKey.VerdictDangerous to "خطرناک",
    WebStringKey.ThreatConfidence to "اطمینان به تهدید",
    WebStringKey.ClearHistory to "پاک کردن همه",
    WebStringKey.ActionBlock to "مسدود و گزارش",
    WebStringKey.ActionQuarantine to "قرنطینه در Sandbox",
    WebStringKey.ExplainableSecurity to "امنیت قابل توضیح",
    WebStringKey.UrlBreakdown to "تفکیک لینک",
    WebStringKey.FullUrl to "لینک کامل",
    WebStringKey.OpenInBrowser to "باز کردن در مرورگر (خطرناک)",
    WebStringKey.RestrictedMode to "حالت محدود",
    WebStringKey.CopyUrl to "کپی لینک",
    WebStringKey.Share to "اشتراک‌گذاری",
    WebStringKey.Dismiss to "بستن",
    WebStringKey.ScanComplete to "اسکن کامل شد",
    WebStringKey.Loading to "در حال بارگذاری...",
    WebStringKey.AnalyzedOffline to "آفلاین در کمتر از 5 میلی‌ثانیه تحلیل شد",
    WebStringKey.NoDataLeaves to "هیچ داده‌ای دستگاه را ترک نمی‌کند",
    WebStringKey.ConfidenceScore to "امتیاز اطمینان",
    WebStringKey.RiskAssessment to "ارزیابی خطر",
    WebStringKey.AnalysisTime to "زمان تحلیل",
    WebStringKey.Heuristics to "اکتشافی",
    WebStringKey.TopAnalysisFactors to "عوامل تحلیل برتر",
    WebStringKey.Pass to "قبول",
    WebStringKey.Clean to "پاک",
    WebStringKey.BackToDashboard to "بازگشت به داشبورد",
    WebStringKey.ShareReport to "اشتراک‌گذاری گزارش",
    WebStringKey.CopyLink to "کپی لینک",
    WebStringKey.LinkCopied to "لینک به کلیپ‌بورد کپی شد!",
    WebStringKey.BeatTheBot to "ربات را شکست دهید",
    WebStringKey.EndSession to "پایان جلسه",
    WebStringKey.Round to "دور",
    WebStringKey.MakeDecision to "تصمیم بگیرید",
    WebStringKey.Phishing to "فیشینگ",
    WebStringKey.Legitimate to "معتبر",
    WebStringKey.LiveScoreboard to "تابلو امتیازات زنده",
    WebStringKey.You to "شما",
    WebStringKey.Points to "امتیاز",
    WebStringKey.Streak to "پیروزی‌های متوالی",
    WebStringKey.Accuracy to "دقت",
    WebStringKey.Confidence to "اطمینان",
    WebStringKey.CorrectDecision to "تصمیم درست!",
    WebStringKey.Correct to "درست!",
    WebStringKey.NextRound to "دور بعدی",
    WebStringKey.GameOver to "بازی تمام شد!",
    WebStringKey.FinalResults to "نتایج نهایی",
    WebStringKey.YourScore to "امتیاز شما",
    WebStringKey.BotScore to "امتیاز ربات",
    WebStringKey.BestStreak to "بهترین پیروزی متوالی",
    WebStringKey.PlayAgain to "دوباره بازی کنید",
    WebStringKey.ReturnToDashboard to "بازگشت به داشبورد",
    WebStringKey.ExportSecurityReport to "صادر کردن گزارش امنیتی",
    WebStringKey.ReportFormat to "فرمت گزارش",
    WebStringKey.Last7Days to "7 روز گذشته",
    WebStringKey.Last30Days to "30 روز گذشته",
    WebStringKey.AllTime to "همه زمان‌ها",
    WebStringKey.GenerateExport to "صادر کردن گزارش",
    WebStringKey.Success to "موفقیت!",
    WebStringKey.Error to "خطا",
    WebStringKey.Warning to "هشدار",
    WebStringKey.CopiedToClipboard to "به کلیپ‌بورد کپی شد",
    WebStringKey.Cancel to "لغو",
    WebStringKey.Confirm to "تأیید",
    WebStringKey.Save to "ذخیره",
    WebStringKey.Delete to "حذف",
    WebStringKey.Edit to "ویرایش",
    WebStringKey.Close to "بستن",
    WebStringKey.Back to "بازگشت",
    WebStringKey.Next to "بعدی",
    WebStringKey.Search to "جستجو",
    WebStringKey.Filter to "فیلتر",
    WebStringKey.Sort to "مرتب‌سازی",
    WebStringKey.Scan to "اسکن",
    WebStringKey.Result to "نتیجه",
    WebStringKey.Copy to "کپی",
    WebStringKey.LivePreview to "پیش‌نمایش زنده",
    WebStringKey.Verdict to "رأی",
    WebStringKey.RiskScore to "امتیاز خطر",
    WebStringKey.TargetUrl to "لینک هدف",
    WebStringKey.AllowList to "لیست مجاز",
    WebStringKey.BlockList to "لیست مسدود",
    WebStringKey.AddDomain to "افزودن دامنه",
    WebStringKey.TrustedDomains to "دامنه‌های مورد اعتماد",
    WebStringKey.BlockedDomains to "دامنه‌های مسدود",
    WebStringKey.Safe to "امن",
    WebStringKey.Suspicious to "مشکوک",
    WebStringKey.Critical to "بحرانی",
    WebStringKey.PhishingDetectionSensitivity to "حساسیت تشخیص فیشینگ",
    WebStringKey.SensitivityLow to "پایین",
    WebStringKey.SensitivityBalanced to "متعادل",
    WebStringKey.SensitivityParanoia to "پارانویا",
    WebStringKey.PrivacyControls to "کنترل‌های حریم خصوصی",
    WebStringKey.StrictOfflineMode to "حالت آفلاین سخت‌گیرانه",
    WebStringKey.AnonymousTelemetry to "تلمتری ناشناس",
    WebStringKey.AutoCopySafeLinks to "کپی خودکار لینک‌های امن",
    WebStringKey.PrivacyPolicy to "سیاست حریم خصوصی",
    WebStringKey.ResetAllSettings to "بازنشانی تمام تنظیمات به پیش‌فرض",
    WebStringKey.AddToAllowlist to "افزودن به لیست مجاز",
    WebStringKey.AddToBlocklist to "افزودن به لیست مسدود",
    WebStringKey.OnDeviceAnalysis to "تحلیل روی دستگاه",
    WebStringKey.NoCloudLogs to "بدون گزارش‌های ابری",
    WebStringKey.OnDeviceDB to "پایگاه داده روی دستگاه",
    WebStringKey.SecurityAuditPass to "ممیزی امنیتی: قبول",
    WebStringKey.Support to "پشتیبانی",
    WebStringKey.Terms to "شرایط",
    WebStringKey.SystemsOperational to "سیستم‌ها فعال",
    WebStringKey.SystemSecure to "سیستم امن",
    WebStringKey.KeyboardShortcuts to "میانبرهای صفحه‌کلید",
    WebStringKey.StartScanner to "شروع اسکنر",
    WebStringKey.CloseMenuModal to "بستن منو / پنجره",
    WebStringKey.NavigateToDashboard to "رفتن به داشبورد",
    WebStringKey.NavigateToHistory to "تاریخچه اسکن",
    WebStringKey.NavigateToTrust to "مرکز اعتماد / لیست مجاز",
    WebStringKey.NavigateToGame to "بازی ربات را شکست دهید",
    WebStringKey.ShowHelp to "نمایش راهنما",
    WebStringKey.GotIt to "فهمیدم",
    WebStringKey.SecuritySettings to "تنظیمات امنیتی",
    WebStringKey.SensitivityLevel to "سطح حساسیت",
    WebStringKey.AutoBlockThreats to "مسدود کردن خودکار تهدیدات",
    WebStringKey.RealTimeScanning to "اسکن بلادرنگ",
    WebStringKey.SoundAlerts to "هشدارهای صوتی",
    WebStringKey.ThreatAlerts to "هشدارهای تهدید",
    WebStringKey.ShowConfidenceScore to "نمایش امتیاز اطمینان",
    WebStringKey.CompactView to "نمای فشرده",
    WebStringKey.ResetDefaults to "بازنشانی به پیش‌فرض",
    WebStringKey.SaveAndContinue to "ذخیره و ادامه",
    WebStringKey.IncorrectDecision to "تصمیم اشتباه",
    WebStringKey.ResponseTime to "زمان پاسخ",

    // Missing keys - Full Persian translations
    WebStringKey.AboutMehrGuard to "درباره Mehr Guard",
    WebStringKey.MehrGuardBot to "ربات Mehr Guard",
    WebStringKey.AccuracyPercent to "دقت",
    WebStringKey.Acknowledgements to "تشکر و قدردانی",
    WebStringKey.ActionBlockDesc to "جلوگیری از دسترسی و اطلاع به مدیر",
    WebStringKey.ActionQuarantineDesc to "باز کردن ایمن برای تحلیل",
    WebStringKey.ActiveProtection to "حفاظت فعال",
    WebStringKey.AddManually to "افزودن دستی",
    WebStringKey.AddToAllowlistTitle to "افزودن به لیست مجاز",
    WebStringKey.AddToBlocklistTitle to "افزودن به لیست مسدود",
    WebStringKey.AddedDaysAgo to "اضافه شده ۲ روز پیش",
    WebStringKey.AddedWeekAgo to "اضافه شده ۱ هفته پیش",
    WebStringKey.AiNeuralAnalysis to "تحلیل عصبی هوش مصنوعی",
    WebStringKey.AllSystemsOperational to "همه سیستم‌ها فعال",
    WebStringKey.AnalysedOfflineTitle to "آفلاین تحلیل شده.",
    WebStringKey.Analysis to "تحلیل",
    WebStringKey.AnalysisSummaryLabel to "خلاصه تحلیل",
    WebStringKey.Analyzing to "در حال تحلیل...",
    WebStringKey.Arabic to "عربی",
    WebStringKey.AttackHomographDesc to "کاراکترهای سیریلیک تقلید کننده الفبای لاتین شناسایی شد.",
    WebStringKey.AttackHomographExplain to "دامنه از 'а' سیریلیک (U+0430) به جای 'a' لاتین (U+0061) استفاده می‌کند. این تکنیک برای فریب کاربران استفاده می‌شود.",
    WebStringKey.AttackHomographTitle to "حمله هموگراف / IDN",
    WebStringKey.AttackJsDesc to "رشته با آنتروپی بالا در پارامترهای URL شناسایی شد.",
    WebStringKey.AttackJsTitle to "جاوااسکریپت مبهم",
    WebStringKey.AttackPunycodeLabel to "Punycode واقعی",
    WebStringKey.AttackRedirectDesc to "۳ پرش با کوتاه‌کننده‌های URL شناخته شده شناسایی شد.",
    WebStringKey.AttackRedirectTitle to "زنجیره تغییر مسیر مشکوک",
    WebStringKey.AttackVisualLabel to "ظاهر بصری",
    WebStringKey.BalancedModeDesc to "الگوهای مخرب شناخته شده را جستجو می‌کند. حملات هموگراف و زنجیره‌های تغییر مسیر را مسدود می‌کند.",
    WebStringKey.BalancedModeRecommended to "حالت متعادل (پیشنهادی)",
    WebStringKey.BeatTheBotAction to "ربات را شکست بده →",
    WebStringKey.BeatTheBotDesc to "موتور هوش مصنوعی آفلاین ما را به چالش بکشید. آیا می‌توانید فیشینگ را سریع‌تر تشخیص دهید؟",
    WebStringKey.BlacklistStatus to "وضعیت لیست سیاه",
    WebStringKey.BlacklistStatusDesc to "در ۵۲ پایگاه داده تهدید محلی یافت نشد.",
    WebStringKey.Brand to "برند",
    WebStringKey.BreadcrumbHome to "خانه",
    // New sensitivity and signal keys
    WebStringKey.LowSensitivityMode to "حالت حساسیت کم",
    WebStringKey.LowSensitivityModeDesc to "فقط URLهای مخرب شناخته شده از پایگاه داده تهدیدات را مسدود می‌کند. خطای مثبت حداقلی، اما ممکن است حملات جدید را از دست بدهد.",
    WebStringKey.ParanoiaMode to "حالت پارانویا",
    WebStringKey.ParanoiaModeDesc to "حداکثر حفاظت. هر الگوی مشکوکی از جمله دامنه‌های تازه ثبت شده، TLDهای غیر معمول و هر URL با ترفندهای رمزگذاری بالقوه را مسدود می‌کند.",
    WebStringKey.PrivacyGuaranteeDesc to "Mehr Guard از موتورهای تحلیل اکتشافی محلی استفاده می‌کند. هیچ داده تصویری، رشته URL یا فراداده‌ای در طول اسکن از این دستگاه خارج نمی‌شود. حریم خصوصی شما به صورت ریاضی تضمین شده است.",
    WebStringKey.SignalBrandImpersonation to "جعل هویت برند بالقوه شناسایی شد",
    WebStringKey.SignalCredentialParams to "پارامترهای مربوط به اعتبارنامه در URL",
    WebStringKey.SignalEncodedPayload to "داده رمزگذاری شده در پارامترهای query شناسایی شد",
    WebStringKey.SignalExcessiveSubdomains to "عمق بیش از حد زیردامنه ({count} سطح)",
    WebStringKey.SignalHighEntropyHost to "تصادفی بودن بالا در نام دامنه",
    WebStringKey.SignalHomographAttack to "دامنه حاوی کاراکترهای هموگراف/قابل اشتباه است",
    WebStringKey.SignalHttpNotHttps to "از پروتکل HTTP ناامن استفاده می‌کند",
    WebStringKey.SignalIpAddressHost to "میزبان یک آدرس IP است به جای دامنه",
    WebStringKey.SignalLongUrl to "URL غیر معمول طولانی ({length} کاراکتر)",
    WebStringKey.SignalLongUrlMarketing to "URL غیر معمول طولانی ({length} کاراکتر) - شامل پارامترهای بازاریابی",
    WebStringKey.SignalNewlyRegisteredDomain to "دامنه تازه ثبت شده شناسایی شد",
    WebStringKey.SignalNonStandardPort to "پورت غیر استاندارد: {port}",
    WebStringKey.SignalNumericSubdomain to "زیردامنه فقط عددی شناسایی شد",
    WebStringKey.SignalSuspiciousPathKeywords to "کلمات کلیدی مشکوک در مسیر ({count} یافت شد)",
    WebStringKey.SignalSuspiciousTld to "TLD مشکوک: {tld}",
    WebStringKey.SignalUrlShortener to "از سرویس کوتاه‌کننده URL استفاده می‌کند",
    WebStringKey.BreadcrumbScans to "اسکن‌ها",
    WebStringKey.BrowserPreview to "پیش‌نمایش مرورگر",
    WebStringKey.CameraAccessDescription to "تصویر کد QR را اینجا بکشید یا دسترسی به دوربین را فعال کنید.",
    WebStringKey.CertificateIssuer to "صادرکننده گواهی با مالک دامنه مطابقت دارد",
    WebStringKey.ChineseSimplified to "چینی (ساده‌شده)",
    WebStringKey.ChooseFormat to "انتخاب فرمت",
    WebStringKey.Clear to "پاک کردن",
    WebStringKey.ComponentVoting to "رأی‌گیری مؤلفه‌ها",
    WebStringKey.ConfidencePercent to "اطمینان",
    WebStringKey.CopyTrustedUrls to "کپی لینک‌های مورد اعتماد به کلیپ‌بورد.",
    WebStringKey.Copyright to "© 2025-2026 Mehr Guard Security Inc. کلیه حقوق محفوظ است.",
    WebStringKey.CoreVersion to "Core v2.4.1 • Build 2025.12.29",
    WebStringKey.CustomRange to "بازه سفارشی",
    WebStringKey.DangerousWarning to "این لینک به عنوان خطرناک علامت‌گذاری شده. باز کردن آن ممکن است شما را در معرض فیشینگ یا بدافزار قرار دهد.",
    WebStringKey.DataLifecycleVerification to "تأیید چرخه عمر داده",
    WebStringKey.DateRange to "بازه تاریخ",
    WebStringKey.DetailLabel to "برچسب جزئیات",
    WebStringKey.DetailValue to "مقدار جزئیات",
    WebStringKey.Detected to "شناسایی شده: ",
    WebStringKey.DisableExternalPreviews to "غیرفعال کردن همه پیش‌نمایش‌های لینک خارجی.",
    WebStringKey.DomainAgeTrust to "سن دامنه > ۵ سال (اعتماد بالا)",
    WebStringKey.DomainPlaceholder to "دامنه وارد کنید (مثال: example.com)",
    WebStringKey.EducationalNote to "یادداشت آموزشی",
    WebStringKey.EngineStatus to "موتور v2.4 • به‌روزرسانی ۲ ساعت پیش",
    WebStringKey.English to "انگلیسی",
    WebStringKey.EnterDomainPrompt to "دامنه‌ای برای افزودن به لیست وارد کنید",
    WebStringKey.EstablishedDomain to "دامنه تثبیت‌شده",
    WebStringKey.EstablishedDomainDesc to "دامنه بیش از ۵ سال پیش ثبت شده. احتمال کلاهبرداری پایین.",
    WebStringKey.ExecutiveSummary to "خلاصه اجرایی",
    WebStringKey.Expected to "مورد انتظار: ",
    WebStringKey.ExportInfoNote to "خروجی شامل تمام بردارهای تهدید شناسایی شده و تحلیل بار است.",
    WebStringKey.ExportReport to "صادر کردن گزارش",
    WebStringKey.ExportReportDesc to "تولید گزارش امنیتی PDF یا JSON",
    WebStringKey.FeatureExplainableDesc to "فقط \"مسدود\" نیست. ما تجزیه و تحلیل هیوریستیک دقیق پارامترهای URL و تغییر مسیرها را ارائه می‌دهیم.",
    WebStringKey.FeatureExplainableTitle to "امنیت قابل توضیح",
    WebStringKey.FeatureOfflineDesc to "تمام تحلیل‌ها به صورت محلی انجام می‌شود. داده‌های شما دستگاه را ترک نمی‌کند.",
    WebStringKey.FeatureOfflineTitle to "معماری آفلاین اول",
    WebStringKey.FeaturePerformanceDesc to "بهینه‌شده برای محیط‌های دسکتاپ. اسکن‌ها در کمتر از ۵ میلی‌ثانیه پردازش می‌شوند.",
    WebStringKey.FlagHomograph to "حمله هموگراف",
    WebStringKey.FlagObfuscated to "اسکریپت مبهم",
    WebStringKey.FlagPhishing to "تلاش فیشینگ",
    WebStringKey.French to "فرانسوی",
    WebStringKey.GameEducationalNote to "یادداشت آموزشی",
    WebStringKey.GameHintTitle to "راهنمای بازی",
    WebStringKey.GenerateReport to "تولید گزارش‌های امنیتی جامع از تاریخچه اسکن.",
    WebStringKey.German to "آلمانی",
    WebStringKey.Help to "راهنما",
    WebStringKey.Heuristic to "هیوریستیک",
    WebStringKey.HighPerformanceEngine to "موتور با کارایی بالا",
    WebStringKey.Hindi to "هندی",
    WebStringKey.HoursAgo to "ساعت پیش",
    WebStringKey.HumanReadable to "گزارش قابل خواندن",
    WebStringKey.HumanReadableDesc to "PDF با تجزیه بصری و خلاصه اجرایی",
    WebStringKey.IdentifiedSafe to "شما لینک امن را به درستی شناسایی کردید.",
    WebStringKey.IncomingMessage to "پیام ورودی",
    WebStringKey.Indonesian to "اندونزیایی",
    WebStringKey.Info to "اطلاعات",
    WebStringKey.Italian to "ایتالیایی",
    WebStringKey.Japanese to "ژاپنی",
    WebStringKey.JsonFormatDesc to "فرمت JSON. بهترین برای یکپارچه‌سازی SIEM.",
    WebStringKey.Korean to "کره‌ای",
    WebStringKey.LastUpdate to "آخرین به‌روزرسانی",
    WebStringKey.LatencyMs to "تأخیر",
    WebStringKey.LearnHomograph to "یاد بگیرید چگونه حملات هموگراف پیشرفته QR را شناسایی کنید.",
    WebStringKey.LearnLocalArchitecture to "درباره معماری محلی ما بیاموزید",
    WebStringKey.LiveFeedDisconnected to "فید زنده قطع شده",
    WebStringKey.LiveHint to "راهنمای زنده",
    WebStringKey.LocalDb to "پایگاه داده محلی",
    WebStringKey.MLModel to "مدل ML",
    WebStringKey.MachineReadable to "داده قابل خواندن ماشین",
    WebStringKey.MachineReadableDesc to "فرمت JSON برای یکپارچه‌سازی SIEM",
    WebStringKey.MetaEngine to "موتور",
    WebStringKey.MetaOfflineGuaranteeDesc to "این تصویر به صورت محلی در دستگاه شما تحلیل شد. هیچ داده‌ای به ابر ارسال نشد.",
    WebStringKey.MetaOfflineGuaranteeLabel to "تضمین آفلاین:",
    WebStringKey.MetaSource to "منبع",
    WebStringKey.MetaTime to "زمان اسکن",
    WebStringKey.MinutesAgo to "دقیقه پیش",
    WebStringKey.NoCloudLogsDesc to "ما به طور کامل تلمتری خروجی را برای اسکن‌ها غیرفعال می‌کنیم. نتایج محلی می‌مانند.",
    WebStringKey.NoCustomDomainsBlocked to "هیچ دامنه سفارشی مسدود نشده.",
    WebStringKey.Notifications to "اعلان‌ها",
    WebStringKey.OfflineDescription to "پایگاه داده محلی v2.4.1 فعال. هیچ داده‌ای از دستگاه خارج نمی‌شود.",
    WebStringKey.OfflineGuaranteeDesc to "تحلیل Mehr Guard کاملاً روی دستگاه اجرا می‌شود. داده‌های URL هرگز گوشی را ترک نمی‌کنند.",
    WebStringKey.OfflineProtection to "حفاظت آفلاین",
    WebStringKey.OfflineSecurity to "امنیت آفلاین",
    WebStringKey.OfflineSecurityDesc to "داده‌های شما هرگز این دستگاه را ترک نمی‌کند. تمام پردازش محلی است.",
    WebStringKey.OnDeviceAnalysisDesc to "تمام تشخیص تهدید به صورت محلی روی دستگاه اجرا می‌شود. هیچ داده‌ای خارج نمی‌شود.",
    WebStringKey.OnDeviceDBDesc to "کل پایگاه داده امضای تهدید برای جستجوی میلی‌ثانیه‌ای به دستگاه شما دانلود می‌شود.",
    WebStringKey.OnboardingHeroDesc to "Mehr Guard هر اسکن را با تحلیل امن روی دستگاه پردازش می‌کند. ما امنیت قابل توضیح را اولویت می‌دهیم.",
    WebStringKey.OpenSourceLicenses to "مجوزهای متن‌باز",
    WebStringKey.OpenWarning to "باز کردن این لینک در مرورگر ممکن است شما را در معرض خطرات امنیتی قرار دهد.",
    WebStringKey.PasteUrlTitle to "لینک برای تحلیل جایگذاری کنید",
    WebStringKey.PdfFormatDesc to "فرمت PDF. بهترین برای اشتراک‌گذاری.",
    WebStringKey.Portuguese to "پرتغالی",
    WebStringKey.Previous to "قبلی",
    WebStringKey.ProcessingResults to "در حال پردازش نتایج اسکن...",
    WebStringKey.Profile to "پروفایل",
    WebStringKey.ReadOnly to "فقط خواندنی",
    WebStringKey.ReasonAsn to "IP هدف در ASN پرخطر قرار دارد.",
    WebStringKey.ReasonDomainAge to "سن دامنه کمتر از ۲۴ ساعت است.",
    WebStringKey.ReasonSignatures to "با ۳ امضا در پایگاه داده فیشینگ محلی مطابقت دارد.",
    WebStringKey.RedirectFinal to "مقصد نهایی",
    WebStringKey.RedirectHop to "پرش میانی",
    WebStringKey.RedirectStart to "اسکن کد QR",
    WebStringKey.RemoveDomain to "حذف دامنه",
    WebStringKey.ReportGeneration to "تولید گزارش",
    WebStringKey.ReportGenerationDesc to "پیکربندی فرمت‌ها و دانلود تحلیل تهدید.",
    WebStringKey.ReportSections to "بخش‌های گزارش",
    WebStringKey.Reset to "بازنشانی",
    WebStringKey.ResetConfirm to "این تمام تنظیمات مرکز اعتماد را به پیش‌فرض بازنشانی می‌کند.",
    WebStringKey.Response to "پاسخ",
    WebStringKey.RestrictedDesc to "این لینک به عنوان خطرناک احتمالی علامت‌گذاری شده. قبل از ادامه تحلیل را بررسی کنید.",
    WebStringKey.RoundAnalysis to "تحلیل دور",
    WebStringKey.Russian to "روسی",
    WebStringKey.SafeUrlList to "لیست لینک‌های امن",
    WebStringKey.SampleUserName to "علی احمدی",
    WebStringKey.SampleUserRole to "تحلیلگر امنیت",
    WebStringKey.ScanHint to "ثابت نگه دارید. آفلاین در کمتر از ۵ میلی‌ثانیه تحلیل می‌شود.",
    WebStringKey.ScanTimeline to "خط زمانی اسکن",
    WebStringKey.ScanURLToSeeResults to "یک لینک اسکن کنید تا نتایج دقیق را ببینید.",
    WebStringKey.ScoreLabel to "امتیاز:",
    WebStringKey.SectionActions to "اقدامات پیشنهادی",
    WebStringKey.SectionAttackBreakdown to "تجزیه حمله",
    WebStringKey.SectionMeta to "متا اسکن",
    WebStringKey.SectionOverview to "نمای کلی",
    WebStringKey.SectionReports to "گزارش‌ها",
    WebStringKey.SectionSecurity to "امنیت",
    WebStringKey.SectionTraining to "آموزش",
    WebStringKey.SecureEnvironment to "محیط امن",
    WebStringKey.SensitivityDescription to "آستانه‌های هیوریستیک را تنظیم کنید. حساسیت بالاتر ممکن است هشدارهای نادرست را افزایش دهد.",
    WebStringKey.SessionId to "شناسه جلسه",
    WebStringKey.ShareDetectionStats to "اشتراک آمار تشخیص برای بهبود ML.",
    WebStringKey.Spanish to "اسپانیایی",
    WebStringKey.SpottedPhishing to "شما لینک فیشینگ را به درستی شناسایی کردید.",
    WebStringKey.SslCertificateDesc to "گواهی توسط DigiCert Inc صادر شده. بدون ناهنجاری در زنجیره اعتماد.",
    WebStringKey.StreakFire to "رشته",
    WebStringKey.Submit to "ارسال",
    WebStringKey.TLD to "TLD",
    WebStringKey.TechnicalIndicators to "شاخص‌های فنی",
    WebStringKey.Thai to "تایلندی",
    WebStringKey.ThreatAnalysisReport to "گزارش تحلیل تهدید",
    WebStringKey.ThreatBreakdown to "تجزیه تهدید",
    WebStringKey.ThreatMonitor to "مانیتور تهدید",
    WebStringKey.ThreatMonitorDesc to "مشاهده تهدیدات زنده و اجرای ممیزی امنیتی",
    WebStringKey.ThreatsBlocked to "تهدیدات مسدود شده",
    WebStringKey.TimeAgo to "پیش",
    WebStringKey.ToggleLightDarkMode to "تغییر حالت روشن/تاریک",
    WebStringKey.ToggleMenu to "تغییر منو",
    WebStringKey.ToggleTheme to "تغییر تم",
    WebStringKey.TrainingCentre to "مرکز آموزش",
    WebStringKey.TrustCentreDesc to "تنظیمات حریم خصوصی و حساسیت تهدید",
    WebStringKey.Turkish to "ترکی",
    WebStringKey.UrlExamplePlaceholder to "https://example.com",
    WebStringKey.UrlInputPlaceholder to "لینک برای تحلیل جایگذاری کنید (مثال: https://example.com)",
    WebStringKey.ValidSslCertificate to "گواهی SSL معتبر",
    WebStringKey.VerdictDangerousDesc to "کد QR حاوی شاخص‌های مخرب مرتبط با فیشینگ و سرقت اعتبار است.",
    WebStringKey.VerifiedBy to "تأیید شده توسط Mehr Guard Enterprise",
    WebStringKey.VersionStatus to "v2.4.1 • سیستم امن",
    WebStringKey.Vietnamese to "ویتنامی",
    WebStringKey.VotingExplanation to "رأی اکثریت تعیین می‌کند: ۳+ امن = سبز، ۲+ مخرب = قرمز",
    WebStringKey.VsMode to "حالت VS",
    WebStringKey.WaitingForAnalysis to "در انتظار تحلیل...",
    WebStringKey.WaitingForScan to "در انتظار اسکن...",
    WebStringKey.Warn to "هشدار",
    WebStringKey.WhitelistedRank to "رتبه Alexa Top 1k در لیست سفید محلی",
    WebStringKey.WhyBotFlagged to "چرا ربات علامت‌گذاری کرد",
    WebStringKey.WrongAnswer to "اوه! این درست نبود.",
    WebStringKey.YourDataStaysOnDevice to "داده‌های شما در دستگاه می‌ماند.",
    
    // Missing Keys - Security Signals & Results
    WebStringKey.AboutDescription to "درباره Mehr Guard Security",
    WebStringKey.ActualDomain to "دامنه واقعی",
    WebStringKey.AnalysisComplete to "تحلیل کامل شد",
    WebStringKey.AutoBlockThreatsDesc to "مسدود کردن خودکار تهدیدها",
    WebStringKey.AwaitingScanLabel to "در انتظار اسکن",
    WebStringKey.BrandImpersonation to "جعل هویت برند",
    WebStringKey.CautionAdvised to "احتیاط توصیه می‌شود",
    WebStringKey.CompactViewDesc to "نمای فشرده",
    WebStringKey.DoNotVisit to "مراجعه نکنید",
    WebStringKey.DoNotVisitDesc to "فیشینگ با اطمینان بالا شناسایی شد. این URL چندین شاخص مخرب دارد.",
    WebStringKey.DomainUsesInternationalChars to "این دامنه از کاراکترهای بین‌المللی استفاده می‌کند که ممکن است دامنه‌های معتبر را تقلید کنند.",
    WebStringKey.GoToScanner to "رفتن به اسکنر",
    WebStringKey.Hebrew to "عبری",
    WebStringKey.HelpKeyboardShortcuts to "میانبرهای صفحه‌کلید",
    WebStringKey.HeuristicAnalysis to "تحلیل هیوریستیک",
    WebStringKey.HeuristicAnalysisDesc to "URL بر اساس چندین عامل خطر شناسایی شده توسط موتور تحلیل علامت‌گذاری شده است.",
    WebStringKey.HiddenDestination to "مقصد پنهان",
    WebStringKey.HighRisk to "خطر بالا",
    WebStringKey.HighRiskLabel to "خطر بالا",
    WebStringKey.HomographIdnAttack to "حمله هموگراف / IDN",
    WebStringKey.InternationalizedDomainDetected to "دامنه بین‌المللی شناسایی شد.",
    WebStringKey.JustNow to "همین الان",
    WebStringKey.KeyboardShortcutsDesc to "میانبرهای صفحه‌کلید برای دسترسی سریع",
    WebStringKey.LiveFeedActive to "فید زنده فعال",
    WebStringKey.LowRisk to "خطر کم",
    WebStringKey.LowRiskLabel to "خطر کم",
    WebStringKey.Malicious to "مخرب",
    WebStringKey.MediumRiskLabel to "خطر متوسط",
    WebStringKey.NoData to "بدون داده",
    WebStringKey.NoScanDataResults to "داده اسکن موجود نیست. لطفاً یک URL اسکن کنید تا نتایج تحلیل را ببینید.",
    WebStringKey.NoUrlScanned to "URL اسکن نشده",
    WebStringKey.Persian to "فارسی",
    WebStringKey.PhishingIndicators to "شاخص‌های فیشینگ",
    WebStringKey.ProceedWithCaution to "با احتیاط ادامه دهید",
    WebStringKey.ProceedWithCautionDesc to "برخی شاخص‌های مشکوک شناسایی شد. قبل از وارد کردن اطلاعات حساس منبع را تأیید کنید.",
    WebStringKey.RealTimeScanningDesc to "اسکن بلادرنگ",
    WebStringKey.RedirectShortenerDetected to "تغییر مسیر/کوتاه‌کننده شناسایی شد",
    WebStringKey.SafeToVisit to "امن برای بازدید",
    WebStringKey.SafeToVisitDesc to "تأیید شده توسط هیوریستیک محلی v2.4. هیچ الگوی فیشینگ، اسکریپت مبهم یا تطابق لیست سیاه یافت نشد.",
    WebStringKey.SafetyScore to "امتیاز امنیت",
    WebStringKey.ScanCompleteLabel to "اسکن کامل شد",
    WebStringKey.ScanToAnalyze to "یک کد QR اسکن کنید یا URL وارد کنید برای تحلیل.",
    WebStringKey.ScannedURLLabel to "URL اسکن شده",
    WebStringKey.SecuritySignal to "سیگنال امنیتی",
    WebStringKey.SensitivityLevelDesc to "سطح حساسیت",
    WebStringKey.SensitivityPermissive to "مجاز",
    WebStringKey.SensitivityStrict to "سختگیرانه",
    WebStringKey.SettingsDetection to "شناسایی",
    WebStringKey.SettingsDisplay to "نمایش",
    WebStringKey.SettingsLanguage to "زبان",
    WebStringKey.SettingsLanguageDesc to "زبان رابط کاربری را انتخاب کنید",
    WebStringKey.SettingsNotifications to "اعلان‌ها",
    WebStringKey.SettingsSavedAutomatically to "تنظیمات به طور خودکار ذخیره می‌شوند و در جلسات همگام می‌شوند.",
    WebStringKey.ShowConfidenceScoreDesc to "نمایش امتیاز اطمینان",
    WebStringKey.SoundAlertsDesc to "هشدارهای صوتی",
    WebStringKey.SuspiciousDomain to "دامنه مشکوک",
    WebStringKey.SuspiciousEncoding to "رمزگذاری مشکوک",
    WebStringKey.SuspiciousKeywords to "کلمات کلیدی مشکوک",
    WebStringKey.SuspiciousTld to "TLD مشکوک",
    WebStringKey.SuspiciousTldDesc to "دامنه از {tld} TLD استفاده می‌کند که معمولاً با سایت‌های مخرب مرتبط است.",
    WebStringKey.SuspiciousUrlParams to "پارامترهای URL مشکوک",
    WebStringKey.SuspiciousUrlParamsDesc to "URL حاوی پارامترهای پیچیده یا احتمالاً مبهم است.",
    WebStringKey.ThreatAlertsDesc to "هشدارهای تهدید",
    WebStringKey.ThreatDetected to "تهدید شناسایی شد",
    WebStringKey.UnableToDetermine to "امکان تعیین حکم وجود ندارد. لطفاً دوباره تلاش کنید.",
    WebStringKey.Unknown to "نامشخص",
    WebStringKey.UnknownURL to "URL نامشخص",
    WebStringKey.UrlShortenerDesc to "URL از سرویس کوتاه‌کننده استفاده می‌کند که مقصد نهایی را پنهان می‌کند.",
    WebStringKey.UrlShortenerDetected to "کوتاه‌کننده URL شناسایی شد",
    WebStringKey.VersionOfflineReady to "آماده آفلاین",
    WebStringKey.VisualAppearance to "ظاهر بصری",
    WebStringKey.WaitingForAnalysisLabel to "در انتظار تحلیل...",
    
    // Result Screen Verdicts (moved from CommonStrings)
    WebStringKey.Last90Days to "۹۰ روز گذشته",
    WebStringKey.VerdictSuspicious to "فعالیت مشکوک",
    WebStringKey.VerdictWarning to "هشدار",
    WebStringKey.VerdictSuspiciousDesc to "کد QR اسکن شده الگوهای مشکوکی نشان می‌دهد که ممکن است خطرات امنیتی بالقوه داشته باشد. با احتیاط ادامه دهید.",
    WebStringKey.VerdictMinorConcerns to "نگرانی‌های جزئی",
    WebStringKey.VerdictCaution to "احتیاط",
    WebStringKey.VerdictMinorConcernsDesc to "برخی نگرانی‌های امنیتی جزئی شناسایی شد. لینک تا حد زیادی امن به نظر می‌رسد اما بررسی توصیه می‌شود.",
    WebStringKey.VerdictVerifiedSafe to "تأیید شده امن",
    WebStringKey.VerdictSafeLabel to "امن",
    WebStringKey.VerdictVerifiedSafeDesc to "هیچ تهدید امنیتی شناسایی نشد. کد QR به مقصد امن تأیید شده هدایت می‌کند.",
    WebStringKey.VerdictNoActivity to "بدون فعالیت",
    WebStringKey.VerdictAwaitingScan to "در انتظار اسکن",
    WebStringKey.VerdictNoActivityDesc to "داده‌ای برای اسکن موجود نیست. لطفاً یک کد QR اسکن کنید یا URL وارد کنید.",
    WebStringKey.ScanQrToSeeActivity to "برای مشاهده فعالیت خود یک کد QR اسکن کنید",
    
    // Data Lifecycle Table
    WebStringKey.DataPoint to "نقطه داده",
    WebStringKey.ProcessingEnv to "محیط پردازش",
    WebStringKey.ExternalTransmission to "انتقال خارجی",
    WebStringKey.RawImageBuffer to "بافر تصویر خام",
    WebStringKey.LocalMemoryRam to "حافظه محلی (RAM)",
    WebStringKey.TransmissionNone to "هیچ",
    WebStringKey.DecodedUrlPayload to "URL/محتوای رمزگشایی شده",
    WebStringKey.LocalAnalysis to "تحلیل محلی",
    WebStringKey.ThreatVerdictLabel to "حکم تهدید",
    WebStringKey.LocalDatabase to "پایگاه داده محلی",
    
    // Reason Code Titles and Descriptions (for i18n of attack analysis cards)
    // CRITICAL severity
    WebStringKey.ReasonJavascriptUrlTitle to "URL جاوا اسکریپت",
    WebStringKey.ReasonJavascriptUrlDesc to "طرح URL جاوا اسکریپت شناسایی شد - هنگام کلیک کد اجرا می‌شود",
    WebStringKey.ReasonDataUriTitle to "URI داده",
    WebStringKey.ReasonDataUriDesc to "طرح URI داده شناسایی شد - ممکن است حاوی کد مخرب جاسازی شده باشد",
    WebStringKey.ReasonAtSymbolInjectionTitle to "تزریق علامت @",
    WebStringKey.ReasonAtSymbolInjectionDesc to "URL حاوی علامت @ است که نشان‌دهنده تلاش احتمالی برای سرقت اعتبارنامه است",
    // HIGH severity
    WebStringKey.ReasonHomographTitle to "حمله همانندنویسی",
    WebStringKey.ReasonHomographDesc to "نام دامنه بین‌المللی (IDN) ممکن است دامنه دیگری را جعل کند",
    WebStringKey.ReasonMixedScriptTitle to "اسکریپت مختلط",
    WebStringKey.ReasonMixedScriptDesc to "نام میزبان حاوی کاراکترهایی از اسکریپت‌های مختلف است (جعل احتمالی)",
    WebStringKey.ReasonLookalikeCharsTitle to "کاراکترهای شبیه",
    WebStringKey.ReasonLookalikeCharsDesc to "دامنه حاوی کاراکترهای یونیکد است که شبیه حروف ASCII هستند",
    WebStringKey.ReasonZeroWidthCharsTitle to "کاراکترهای با عرض صفر",
    WebStringKey.ReasonZeroWidthCharsDesc to "کاراکترهای یونیکد مخفی با عرض صفر شناسایی شد (تلاش برای مبهم‌سازی)",
    WebStringKey.ReasonIpHostTitle to "میزبان IP",
    WebStringKey.ReasonIpHostDesc to "URL از آدرس IP به جای نام دامنه استفاده می‌کند",
    WebStringKey.ReasonCredentialParamTitle to "پارامتر اعتبارنامه",
    WebStringKey.ReasonCredentialParamDesc to "URL حاوی پارامترهای مربوط به اعتبارنامه است (رمز عبور، توکن و غیره)",
    WebStringKey.ReasonBrandImpersonationTitle to "جعل برند",
    WebStringKey.ReasonBrandImpersonationDesc to "به نظر می‌رسد URL یک برند معروف را جعل می‌کند",
    WebStringKey.ReasonBrandInSubdomainTitle to "برند در زیردامنه",
    WebStringKey.ReasonBrandInSubdomainDesc to "نام برند در زیردامنه ظاهر می‌شود اما در دامنه اصلی نیست",
    WebStringKey.ReasonRiskyExtensionTitle to "پسوند پرخطر",
    WebStringKey.ReasonRiskyExtensionDesc to "مسیر حاوی پسوند فایل بالقوه خطرناک است",
    WebStringKey.ReasonDoubleExtensionTitle to "پسوند دوگانه",
    WebStringKey.ReasonDoubleExtensionDesc to "پسوند فایل دوگانه شناسایی شد (تاکتیک رایج بدافزار)",
    WebStringKey.ReasonEncodedPayloadTitle to "محتوای رمزگذاری شده",
    WebStringKey.ReasonEncodedPayloadDesc to "داده‌های رمزگذاری شده بزرگ در پارامترهای URL شناسایی شد",
    // MEDIUM severity
    WebStringKey.ReasonHttpNotHttpsTitle to "HTTP به جای HTTPS",
    WebStringKey.ReasonHttpNotHttpsDesc to "URL از پروتکل HTTP ناامن به جای HTTPS استفاده می‌کند",
    WebStringKey.ReasonSuspiciousTldTitle to "TLD مشکوک",
    WebStringKey.ReasonSuspiciousTldDesc to "دامنه سطح بالا اغلب برای فیشینگ استفاده می‌شود",
    WebStringKey.ReasonHighEntropyHostTitle to "میزبان با آنتروپی بالا",
    WebStringKey.ReasonHighEntropyHostDesc to "به نظر می‌رسد نام دامنه به صورت تصادفی تولید شده است",
    WebStringKey.ReasonRedirectParamTitle to "پارامتر تغییر مسیر",
    WebStringKey.ReasonRedirectParamDesc to "URL حاوی پارامتر تغییر مسیر است که ممکن است به سایت دیگری هدایت کند",
    WebStringKey.ReasonDeepSubdomainTitle to "زیردامنه عمیق",
    WebStringKey.ReasonDeepSubdomainDesc to "عمق زیردامنه بیش از حد (ممکن است دامنه واقعی را پنهان کند)",
    WebStringKey.ReasonMultiTldTitle to "TLD چندگانه",
    WebStringKey.ReasonMultiTldDesc to "بخش‌های متعدد شبیه TLD در نام دامنه",
    WebStringKey.ReasonNumericSubdomainTitle to "زیردامنه عددی",
    WebStringKey.ReasonNumericSubdomainDesc to "زیردامنه فقط عددی شناسایی شد",
    WebStringKey.ReasonNonStandardPortTitle to "پورت غیراستاندارد",
    WebStringKey.ReasonNonStandardPortDesc to "URL از شماره پورت غیراستاندارد استفاده می‌کند",
    WebStringKey.ReasonSuspiciousPortTitle to "پورت مشکوک",
    WebStringKey.ReasonSuspiciousPortDesc to "URL از پورتی استفاده می‌کند که معمولاً با حملات مرتبط است",
    WebStringKey.ReasonFragmentHidingTitle to "پنهان‌سازی فرگمنت",
    WebStringKey.ReasonFragmentHidingDesc to "به نظر می‌رسد فرگمنت URL محتوای اضافی را پنهان می‌کند",
    WebStringKey.ReasonExcessiveEncodingTitle to "رمزگذاری بیش از حد",
    WebStringKey.ReasonExcessiveEncodingDesc to "رمزگذاری URL بیش از حد شناسایی شد (تلاش برای مبهم‌سازی)",
    WebStringKey.ReasonDomainAgePatternTitle to "الگوی سن دامنه",
    WebStringKey.ReasonDomainAgePatternDesc to "نام دامنه با الگوهای دامنه‌های خودکار تولید شده مطابقت دارد",
    // LOW severity
    WebStringKey.ReasonUrlShortenerTitle to "کوتاه‌کننده URL",
    WebStringKey.ReasonUrlShortenerDesc to "URL از سرویس کوتاه‌سازی استفاده می‌کند (مقصد واقعی را پنهان می‌کند)",
    WebStringKey.ReasonSuspiciousPathTitle to "مسیر مشکوک",
    WebStringKey.ReasonSuspiciousPathDesc to "مسیر حاوی کلمات کلیدی مشکوک است (ورود، تأیید و غیره)",
    WebStringKey.ReasonLongUrlTitle to "URL طولانی",
    WebStringKey.ReasonLongUrlDesc to "URL غیرعادی طولانی",
    WebStringKey.ReasonCredentialKeywordsTitle to "کلمات کلیدی اعتبارنامه",
    WebStringKey.ReasonCredentialKeywordsDesc to "URL حاوی کلمات کلیدی جمع‌آوری اعتبارنامه است",
    // INFO
    WebStringKey.ReasonUnparseableTitle to "URL غیرقابل تجزیه",
    WebStringKey.ReasonUnparseableDesc to "URL به طور کامل قابل تجزیه نبود",
    WebStringKey.ReasonAnalysisCompleteTitle to "تحلیل کامل شد",
    WebStringKey.ReasonAnalysisCompleteDesc to "تحلیل با موفقیت کامل شد",
    
    // ML Score Labels
    WebStringKey.MlPhishingScore to "امتیاز فیشینگ ML",
    WebStringKey.MlCharacterAnalysis to "تحلیل کاراکتر",
    WebStringKey.MlFeatureAnalysis to "تحلیل ویژگی",

    // Unicode Attack Breakdowns (Red Team scenarios)
    WebStringKey.IdnPunycodeDomainTitle to "دامنه IDN / Punycode",
    WebStringKey.IdnPunycodeDomainDesc to "این دامنه از کاراکترهای بین‌المللی استفاده می‌کند. نمایش امن:",
    WebStringKey.MixedScriptAttackTitle to "حمله اسکریپت ترکیبی",
    WebStringKey.MixedScriptAttackDesc to "دامنه شامل کاراکترهایی از اسکریپت‌های مختلف است (مثلاً سیریلیک + لاتین). رایج در حملات هوموگراف.",
    WebStringKey.ConfusableCharsTitle to "کاراکترهای قابل اشتباه",
    WebStringKey.ConfusableCharsDesc to "دامنه شامل کاراکترهایی است که شبیه حروف معمولی هستند (مثلاً 'а' در مقابل 'a')."
)

internal val PersianCommonStrings = mapOf(
    "Dashboard" to "داشبورد",
    "Settings" to "تنظیمات",
    "Language" to "زبان",
    "Scan" to "اسکن",
    "Result" to "نتیجه",
    "Safe" to "امن",
    "Suspicious" to "مشکوک",
    "Dangerous" to "خطرناک",
    "Phishing" to "فیشینگ",
    "Legitimate" to "معتبر",
    "Copy" to "کپی",
    "Share" to "اشتراک‌گذاری",
    "Close" to "بستن",
    "Cancel" to "لغو",
    "Confirm" to "تأیید",
    "Save" to "ذخیره",
    "Delete" to "حذف",
    "Back" to "بازگشت",
    "Next" to "بعدی",
    "Search" to "جستجو",
    "Filter" to "فیلتر",
    "Sort" to "مرتب‌سازی",
    "Error" to "خطا",
    "Warning" to "هشدار",
    "Success" to "موفقیت",
    "Loading" to "در حال بارگذاری...",
    "Active" to "فعال",
    "Version" to "نسخه",
    "Export" to "صادر کردن",
    "Import" to "وارد کردن",
    "Report" to "گزارش",
    "Analysis" to "تحلیل",
    "Security" to "امنیت",
    "Privacy" to "حریم خصوصی",
    "Help" to "راهنما",
    "About" to "درباره",
    "Hebrew" to "عبری",
    "Persian" to "فارسی",
    
    // Game Hints (CommonStrings lookup by exact English text)
    "Check the domain carefully. This appears to be a well-known, trusted domain." to "دامنه را با دقت بررسی کنید. این یک دامنه معروف و قابل اعتماد به نظر می‌رسد.",
    "Look closely at the domain structure. Legitimate organisations rarely use hyphens in the main domain name or generic TLDs like <code>.net</code> for core services." to "ساختار دامنه را با دقت بررسی کنید. سازمان‌های معتبر به ندرت از خط تیره در نام دامنه اصلی یا TLDهای عمومی مانند <code>.net</code> برای خدمات اصلی استفاده می‌کنند.",
    "Look at the domain carefully. Is \"c0mmonwealth\" spelled correctly? The number 0 is often used to replace the letter O." to "دامنه را با دقت بررسی کنید. آیا «c0mmonwealth» درست نوشته شده است؟ عدد 0 اغلب به جای حرف O استفاده می‌شود.",
    "This is a well-established software company domain." to "این دامنه یک شرکت نرم‌افزاری معتبر است.",
    "Apple would never use a third-party domain for account verification. Check the actual domain name." to "اپل هرگز از دامنه شخص ثالث برای تأیید حساب استفاده نمی‌کند. نام دامنه واقعی را بررسی کنید.",
    "This is a Google subdomain - check if it's the legitimate Gmail service." to "این یک زیردامنه گوگل است - بررسی کنید آیا سرویس Gmail معتبر است.",
    "Look at the domain name carefully. Is \"paypa1\" spelled correctly?" to "نام دامنه را با دقت بررسی کنید. آیا «paypa1» درست نوشته شده است؟",
    "This is the official LinkedIn domain for professional networking." to "این دامنه رسمی لینکدین برای شبکه‌سازی حرفه‌ای است.",
    "Short URLs hide the actual destination. Prize claims from unknown numbers are almost always scams." to "URLهای کوتاه مقصد واقعی را پنهان می‌کنند. ادعای جایزه از شماره‌های ناشناس تقریباً همیشه کلاهبرداری است.",
    "Check if this is a legitimate Google subdomain for document sharing." to "بررسی کنید آیا این یک زیردامنه معتبر گوگل برای اشتراک‌گذاری اسناد است.",
    
    // Game Educational Notes
    "Official postal services use their primary domain (auspost.com.au) for all tracking. Verify by visiting the official website directly." to "خدمات پستی رسمی از دامنه اصلی خود (auspost.com.au) برای همه ردیابی‌ها استفاده می‌کنند. با مراجعه مستقیم به وب‌سایت رسمی تأیید کنید.",
    "GitHub.com is a legitimate developer platform owned by Microsoft. Always verify the exact domain spelling." to "GitHub.com یک پلتفرم توسعه‌دهنده معتبر متعلق به مایکروسافت است. همیشه املای دقیق دامنه را تأیید کنید.",
    "Homograph attacks use similar-looking characters. Always check URLs character by character for suspicious substitutions." to "حملات همانندنویسی از کاراکترهای شبیه هم استفاده می‌کنند. همیشه URLها را کاراکتر به کاراکتر برای جایگزینی‌های مشکوک بررسی کنید.",
    "Atlassian is a legitimate software company. Their primary domain atlassian.com is trustworthy." to "Atlassian یک شرکت نرم‌افزاری معتبر است. دامنه اصلی آنها atlassian.com قابل اعتماد است.",
    "Apple only uses apple.com for all account-related activities. Be wary of domains containing brand names but with different extensions." to "اپل فقط از apple.com برای همه فعالیت‌های مرتبط با حساب استفاده می‌کند. مراقب دامنه‌هایی باشید که حاوی نام برند هستند اما پسوندهای متفاوتی دارند.",
    "Google services use subdomains of google.com. mail.google.com is the legitimate Gmail address." to "سرویس‌های گوگل از زیردامنه‌های google.com استفاده می‌کنند. mail.google.com آدرس معتبر Gmail است.",
    "The number 1 and lowercase L look identical in many fonts. Always verify paypal.com directly." to "عدد 1 و حرف L کوچک در بسیاری از فونت‌ها یکسان به نظر می‌رسند. همیشه paypal.com را مستقیماً تأیید کنید.",
    "LinkedIn uses linkedin.com as their primary domain. Profile URLs follow the /in/username format." to "لینکدین از linkedin.com به عنوان دامنه اصلی خود استفاده می‌کند. URLهای پروفایل از فرمت /in/username پیروی می‌کنند.",
    "Never trust shortened URLs from unknown sources. Use URL expander tools to see the real destination before clicking." to "هرگز به URLهای کوتاه شده از منابع ناشناس اعتماد نکنید. از ابزارهای توسعه URL برای دیدن مقصد واقعی قبل از کلیک استفاده کنید.",
    "Google Docs uses docs.google.com. Always verify the sender knows you before opening shared documents." to "Google Docs از docs.google.com استفاده می‌کند. همیشه قبل از باز کردن اسناد به اشتراک گذاشته شده، تأیید کنید که فرستنده شما را می‌شناسد."
)
